import { UiTranslatorController } from "../../controllers";
import { ComponentBase } from "../_ComponentBase";

/**
 * User interface for translating user interfaces
 * @example
 * ```html
 * <salaxy-ui-translator></salaxy-ui-translator>
 * ```
 */
export class UiTranslator extends ComponentBase {

    /**
     * The following component properties (attributes in HTML) are bound to the Controller.
     * For detailed functionality, refer to [controller](#controller) implementation.
     */
    public bindings = {

      /** User interface mode for the component: "table" (default) or "fieldset" */
      mode: "@",

      /**
       * Beginning of the full key that is used to filtering the dictionary items (allKeyValues filter).
       * The value may be a string, array or comma separated string of values.
       */
      filter: "<",

      /** Texts from serviceModel that are being edited */
      texts: "<",
    };

    /** Uses the UiTranslatorController */
    public controller = UiTranslatorController;

    /** The default template for the component. */
    public defaultTemplate = "salaxy-components/helpers/UiTranslator.html";
}
